import type { IUserAdminRepository } from '../../domain/ports';
import { userAdminApi } from '../api';
import type {
  ApiResponse,
  UserAdminDTO,
  UserAdminStatsDTO,
  ListeUtilisateursResult,
  UserFiltersParams,
  MettreAJourUtilisateurData,
} from '../../application/dto/dtos';

/**
 * Adapte userAdminApi vers le port IUserAdminRepository.
 */
export class UserAdminRepository implements IUserAdminRepository {
  listerUtilisateurs(params: UserFiltersParams): Promise<ApiResponse<ListeUtilisateursResult>> {
    return userAdminApi.listerUtilisateurs(params);
  }

  obtenirStatistiques(): Promise<ApiResponse<{ statistiques: UserAdminStatsDTO }>> {
    return userAdminApi.obtenirStatistiques();
  }

  supprimerUtilisateur(idUtilisateur: string): Promise<ApiResponse<void>> {
    return userAdminApi.supprimerUtilisateur(idUtilisateur);
  }

  changerRole(idUtilisateur: string, role: string): Promise<ApiResponse<void>> {
    return userAdminApi.changerRole(idUtilisateur, role);
  }

  basculerActivation(idUtilisateur: string, activer: boolean): Promise<ApiResponse<void>> {
    return userAdminApi.basculerActivation(idUtilisateur, activer);
  }

  verrouillerCompte(idUtilisateur: string, dureeMinutes: number): Promise<ApiResponse<void>> {
    return userAdminApi.verrouillerCompte(idUtilisateur, dureeMinutes);
  }

  deverrouillerCompte(idUtilisateur: string): Promise<ApiResponse<void>> {
    return userAdminApi.deverrouillerCompte(idUtilisateur);
  }

  mettreAJourUtilisateur(idUtilisateur: string, data: MettreAJourUtilisateurData): Promise<ApiResponse<UserAdminDTO>> {
    return userAdminApi.mettreAJourUtilisateur(idUtilisateur, data);
  }

  exporterUtilisateurs(params: { role?: string; isActive?: string }): Promise<Blob> {
    return userAdminApi.exporterUtilisateurs(params);
  }
}
